"use client";

import { GoogleIcon } from "../icons";

const BTN =
  "w-full flex items-center justify-center gap-3 rounded-xl border border-[#1e3248]/70 bg-[#0a1018] px-4 py-2.5 text-[15px] font-medium text-[#c7d5e0] hover:bg-[#0f1824] hover:border-[#2a475e]/60 transition-all duration-200";

export function AuthOAuthButtons({
  onGoogle,
}: {
  onGoogle?: () => void;
}) {
  return (
    <div className="space-y-2.5">
      <button type="button" className={BTN} onClick={onGoogle}>
        <GoogleIcon className="w-5 h-5" />
        <span>Continue with Google</span>
      </button>

      {/* Steam OAuth — disabled for now
      <button type="button" className={BTN}>
        <SteamIcon className="w-5 h-5" />
        <span>Continue with Steam</span>
      </button>
      */}
    </div>
  );
}
